import { Configuration, PopupRequest } from '@azure/msal-browser';

/**
 * MSAL Configuration for Azure AD Authentication
 *
 * Unified configuration for all users (home tenant and federated organizations).
 * Uses multi-tenant authority (/organizations) for authentication.
 * Tokens stored in localStorage for BFF-less authentication pattern.
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: `${window.location.origin}/auth/callback`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

/**
 * Login Request Configuration
 *
 * Uses .default scope to request an access token for the backend API.
 * This automatically includes all permissions configured for the app registration
 * including openid, profile, and email.
 *
 * Why .default:
 * - Returns access token (not ID token) required for backend API authentication
 * - Backend validates access token signature using Azure AD public keys
 * - Simpler than exposing custom API scopes in Azure Portal
 * - Recommended pattern for SPA + backend API scenarios
 */
export const loginRequest: PopupRequest = {
  scopes: [`${import.meta.env.VITE_AZURE_CLIENT_ID}/.default`],
};
